import { FC } from "react";
import "../../components/OrderTracking/styles.scss";
import RefundDetailComp from "../../components/RefundDetailComp";

const RefundDetailPage: FC = () => {
  return <RefundDetailComp />;
};

export default RefundDetailPage;
